/* ===== The Pawlish Pro Track Order - scoped form lifecycle ===== */
(function () {
  if (window.PawlishTrackOrder && typeof window.PawlishTrackOrder.init === 'function') {
    window.PawlishTrackOrder.init(document);
    return;
  }

  var instances = new WeakMap();

  function getRoots(scope) {
    var roots = [];
    var context = scope && scope.querySelectorAll ? scope : document;

    if (context.matches && context.matches('[data-pro-track-order]')) roots.push(context);

    context.querySelectorAll('[data-pro-track-order]').forEach(function (root) {
      roots.push(root);
    });

    return roots;
  }

  function cleanTrackingNumber(value) {
    return String(value || '').trim().replace(/\s+/g, '');
  }

  function buildTrackingUrl(root, number) {
    var encoded = encodeURIComponent(number);
    var provider = root.dataset.provider || '17track';
    var customUrl = root.dataset.customUrl || '';

    if (provider === 'aftership') {
      return 'https://www.aftership.com/track/' + encoded;
    }

    if (provider === 'parcelsapp') {
      return 'https://parcelsapp.com/en/tracking/' + encoded;
    }

    if (provider === 'custom' && customUrl) {
      if (customUrl.indexOf('[tracking_number]') !== -1) {
        return customUrl.replace('[tracking_number]', encoded);
      }

      return customUrl + encoded;
    }

    return 'https://t.17track.net/en#nums=' + encoded;
  }

  function showError(message, text) {
    message.className = 'pro-track-order__message is-error';
    message.textContent = text;
  }

  function showSuccess(message, text, number, url) {
    var link = document.createElement('a');

    message.className = 'pro-track-order__message is-success';
    message.textContent = '';
    message.appendChild(document.createTextNode(text + ' '));

    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener';
    link.textContent = number;
    message.appendChild(link);
  }

  function initRoot(root) {
    if (instances.has(root)) return;

    var form = root.querySelector('[data-pro-track-form]');
    var input = root.querySelector('[data-pro-track-input]');
    var message = root.querySelector('[data-pro-track-message]');

    if (!form || !input || !message) return;

    var controller = new AbortController();

    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();

        var number = cleanTrackingNumber(input.value);
        var errorMessage = root.dataset.errorMessage || '';
        var successMessage = root.dataset.successMessage || '';

        if (!number) {
          showError(message, errorMessage);
          input.focus();
          return;
        }

        var url = buildTrackingUrl(root, number);
        var openNewTab = root.dataset.openNewTab === 'true';

        showSuccess(message, successMessage, number, url);

        if (openNewTab) {
          var trackingWindow = window.open(url, '_blank', 'noopener,noreferrer');
          if (trackingWindow) trackingWindow.opener = null;
        } else {
          window.location.assign(url);
        }
      },
      { signal: controller.signal }
    );

    root.dataset.proTrackOrderReady = 'true';

    instances.set(root, {
      destroy: function () {
        controller.abort();
        root.removeAttribute('data-pro-track-order-ready');
      },
    });
  }

  function destroyRoot(root) {
    var instance = instances.get(root);
    if (!instance) return;

    instance.destroy();
    instances.delete(root);
  }

  function init(scope) {
    getRoots(scope).forEach(initRoot);
  }

  function destroyWithin(scope) {
    getRoots(scope).forEach(destroyRoot);
  }

  window.PawlishTrackOrder = {
    init: init,
    destroyWithin: destroyWithin,
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        init(document);
      },
      { once: true }
    );
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyWithin(event.target);
  });
})();
